export default {
  setGlobalErrorModal(context, val) {
    context.commit('setGlobalErrorModal', val);
  },
  pushError(context, val) {
    context.commit('pushError', val);
  },
};
